import api from './api';

export const ledgerApi = {
  getBalance: async () => {
    const response = await api.get('/me/balance');
    return response.data;
  },
  getLedger: async (cursor?: string, limit?: number) => {
    const params = new URLSearchParams();
    if (cursor) params.append('cursor', cursor);
    if (limit) params.append('limit', limit.toString());
    const response = await api.get(`/me/ledger?${params.toString()}`);
    return response.data;
  },
  getWithdrawalForecast: async () => {
    const response = await api.get('/me/withdrawal-forecast');
    return response.data;
  },
};
